"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = _interopRequireDefault(require("../../../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var VideoItemPlaceholder =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(VideoItemPlaceholder, _React$Component);

  function VideoItemPlaceholder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = VideoItemPlaceholder.prototype;

  _proto.render = function render() {
    var baseClassName = 'gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item';
    return _react["default"].createElement("div", {
      key: 'video-and-hover-container' + this.props.id
    }, _react["default"].createElement("div", {
      className: baseClassName,
      key: 'video-placeholder-container-' + this.props.id,
      style: _utils["default"].deviceHasMemoryIssues() ? {} : {
        backgroundImage: "url(" + this.props.resized_url.thumb + ")"
      }
    }, this.props.hover, _react["default"].createElement("div", {
      className: "gallery--placeholder-item",
      key: 'video-' + this.props.id
    })));
  };

  return VideoItemPlaceholder;
}(_react["default"].Component);

var _default = VideoItemPlaceholder;
exports["default"] = _default;